import Rank from 'records/Rank';
import {Record} from 'immutable';

export default class UserActivityRanks extends Record({
  callActivity: undefined,
  selfReviewActivity: undefined,
  userId: undefined,
}) {
  constructor(props: any = {}) {
    super({
      ...props,
      callActivity: props.callActivityRank ? new Rank(props.callActivityRank) : undefined,
      selfReviewActivity: props.selfReviewRank ? new Rank(props.selfReviewRank) : undefined,
    });
  }
}
